import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Features from './components/Features';
import RecentBlogs from './components/RecentBlogs';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://documogul.com';
    
    // 动态设置页面标题和meta标签
    document.title = '星允信息 - PDF SDK智能文档处理解决方案';
    
    // 更新meta描述
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '星允信息提供专业的Adobe PDF Library SDK、PDF转换器和智能表单处理系统，帮助企业实现文档数字化转型。支持跨平台集成，提供技术支持和定制化解决方案。');
    }

    // 更新关键词
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'PDF SDK,Adobe PDF Library,PDF转换器,智能表单处理,文档数字化,广州PDF服务,企业文档管理,电子签名,OCR识别');
    }
    
    // 添加综合结构化数据
    const structuredData = [
      // LocalBusiness
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "星允信息科技有限公司",
        "image": `${siteUrl}/og-image.png`,
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "天河区",
          "addressLocality": "广州市",
          "addressRegion": "广东省",
          "addressCountry": "CN"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "23.1291",
          "longitude": "113.2644"
        },
        "url": siteUrl,
        "telephone": "+86-20-XXXXXXXX",
        "priceRange": "$$",
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "18:00"
          }
        ]
      },
      // Organization
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "星允信息科技有限公司",
        "url": siteUrl,
        "logo": `${siteUrl}/og-image.png`,
        "description": "星允信息提供专业的Adobe PDF Library SDK、PDF转换器和智能表单处理系统，帮助企业实现文档数字化转型。",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "广州市",
          "addressRegion": "广东省",
          "addressCountry": "CN"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "customer service",
          "availableLanguage": ["zh-CN", "en"]
        }
      },
      // WebSite
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "星允信息",
        "url": siteUrl,
        "potentialAction": {
          "@type": "SearchAction",
          "target": `${siteUrl}/search?q={search_term_string}`,
          "query-input": "required name=search_term_string"
        }
      },
      // BreadcrumbList
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": siteUrl
          }
        ]
      },
      // FAQPage
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "什么是Adobe PDF Library SDK？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Adobe PDF Library SDK是一个专业的PDF处理开发工具包，支持C++、.NET、Java等多种开发语言，可以帮助企业快速集成PDF处理功能到自己的应用系统中。"
            }
          },
          {
            "@type": "Question",
            "name": "星允信息提供哪些PDF解决方案？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "星允信息提供Adobe PDF Library SDK、PDF转换器、智能表单处理系统、PDF REST容器等多种企业级PDF处理解决方案，支持跨平台集成和定制化开发。"
            }
          },
          {
            "@type": "Question",
            "name": "如何联系星允信息获取技术支持？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "您可以通过我们的在线客服、电话或邮件联系我们，我们的技术团队将为您提供专业的技术支持和解决方案咨询服务。"
            }
          }
        ]
      }
    ];

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <Features />
        <RecentBlogs />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
